import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

function SettingMenuDropdown(props) {
  const dropdownRef = useRef(null);
  const toggleTimeout = useRef(null);
  const {
    children = null,
    button = null,
    className = 'tv-setting-dropdown__element',
    text = 'setting-dropdown',
  } = props;
  const [showDropDown, setShowDropDown] = useState(false);

  const toggleMenu = () => {
    if (toggleTimeout.current) {
      clearTimeout(toggleTimeout.current);
    }
    toggleTimeout.current = setTimeout(() => {
      setShowDropDown(prevVisible => !prevVisible);
    }, 200);
  };

  const onBlur = event => {
    const { currentTarget } = event;
    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        // toggleMenu();
        setShowDropDown(false);
      }
    }, 250);
  };

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape' && showDropDown) {
        setShowDropDown(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [showDropDown]);

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropDown(false);
    }
  };

  useEffect(() => {
    const handleCustomEvent = event => {
      handleClickOutside(event);
    };

    document.addEventListener('customMousedown', handleCustomEvent);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('customMousedown', handleCustomEvent);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} onBlur={onBlur} className={className}>
      <div
        role="button"
        tabIndex={0}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          toggleMenu();
        }}
        onKeyDown={e => (e.key === 'Enter' ? toggleMenu() : '')}
        aria-label={text}
        className="tv-setting-dropdown__button"
      >
        {button}
      </div>
      {showDropDown && children}
    </div>
  );
}

SettingMenuDropdown.propTypes = {
  children: PropTypes.node,
  button: PropTypes.node,
  className: PropTypes.string,
  text: PropTypes.string,
};

export default SettingMenuDropdown;
